var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meetings-iframe-container w-full  rounded-md  overflow-y-scroll bg-main-4 pt-2",staticStyle:{"max-height":"100% !important"},style:({
    transform: ("scale(" + _vm.scale + ")")
  }),attrs:{"data-src":"https://meetings.hubspot.com/cognni?embed=true"}})}
var staticRenderFns = []

export { render, staticRenderFns }